import React from "react";

import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import { Container, Typography } from "@mui/material";

import ROUTES from "@app/common/routes";
import Config from "@app/config";
import { usePageTitle } from "@app/utils/hooks";

import Stack, { Row } from "@rui/Stack";
import { StickyContainer } from "@rui/styles";
import Tab from "@rui/Tab";
import Tabs, { TabsContainer } from "@rui/Tabs";

import Newsfeed from "./Newsfeed";
import Saved from "./Saved";
import ActionBar from "../components/ActionBar";

const TABS: { label: string; path: string }[] = [
  {
    label: "Newsfeed",
    path: ROUTES.NEWSFEED,
  },
  {
    label: "Later",
    path: ROUTES.NEWSFEED_SAVED,
  },
];

const Home = () => {
  usePageTitle("Home");

  const navigate = useNavigate();

  const handleTabChange = (_event: React.SyntheticEvent, path: string) => {
    navigate(path);
  };

  return (
    <Stack sx={{ backgroundColor: "shades.ghost.300", flex: 1 }}>
      <StickyContainer>
        <ActionBar
          sx={{ ...(Config.flags.enableHomepageTabs && { borderBottom: 0 }) }}
        >
          <Row variant="left" spacing={1}>
            <Typography variant="h2">Home</Typography>
          </Row>
        </ActionBar>
        {Config.flags.enableHomepageTabs && (
          <TabsContainer>
            <Tabs value={location.pathname} onChange={handleTabChange}>
              {TABS.map((tab) => (
                <Tab key={tab.path} value={tab.path} label={tab.label} />
              ))}
            </Tabs>
          </TabsContainer>
        )}
      </StickyContainer>
      <Container maxWidth="xl" sx={{ pt: 1, pb: 4, flex: 1 }}>
        <Routes>
          <Route index element={<Newsfeed />} />
          {Config.flags.enableHomepageTabs && (
            <Route path="saved" element={<Saved />} />
          )}
          <Route path="*" element={<Navigate to={ROUTES.NEWSFEED} />} />
        </Routes>
      </Container>
    </Stack>
  );
};

export default Home;
